import uniq from "lodash/uniq";
import { useMemo } from "react";
import useGetTasksBatch from "../../Tasks/hooks/useGetTasksBatch";
import { createErrorState, createLoadingState, createSuccessState, getFirstQueryError, hasAnyQueryError, isAnyQueryLoading, } from "../utils/hookStateHelpers";
import useGetTransitions from "./useGetTransitions";
export const useGetAllAdvisorTransitions = (authConfig, advisorId, queryParams) => {
    const transitionsQueryParams = useMemo(() => ({
        pageSize: 1000,
        page: 1,
        ...queryParams,
    }), [queryParams]);
    const transitionsQuery = useGetTransitions(transitionsQueryParams, authConfig);
    const taskIds = useMemo(() => {
        const transitions = transitionsQuery.data?.advisorTransitions ?? [];
        return uniq(transitions.map((transition) => transition.taskId));
    }, [transitionsQuery.data?.advisorTransitions]);
    const tasksQuery = useGetTasksBatch({
        taskIds,
        advisorId,
    }, authConfig);
    const queries = [transitionsQuery, tasksQuery];
    const transitionsDto = useMemo(() => {
        const transitions = transitionsQuery.data?.advisorTransitions ?? [];
        if (tasksQuery.data?.values === undefined) {
            return [];
        }
        const taskMap = new Map(tasksQuery.data.values.map((task) => [task.id, task]));
        return transitions
            .map((transition) => {
            const task = taskMap.get(transition.taskId);
            return {
                ...transition,
                task: task,
            };
        })
            .filter((transition) => Boolean(transition.task));
    }, [transitionsQuery.data?.advisorTransitions, tasksQuery.data?.values]);
    if (isAnyQueryLoading(queries)) {
        return createLoadingState();
    }
    if (hasAnyQueryError(queries)) {
        return createErrorState(getFirstQueryError(queries));
    }
    return createSuccessState(transitionsDto);
};
export default useGetAllAdvisorTransitions;
//# sourceMappingURL=useGetAllAdvisorTransitions.js.map